import styled from 'styled-components'

const EmbedResponsive = styled.div(
  ({ theme }) => `
  position: relative;
  margin-top: calc(-3em - 200px);
  padding-bottom: 56.25%;
  
  @media (max-width: ${theme.breakpoints.sm.max}) {
    padding-bottom: 60%;
    margin-top: calc(-200px);
    margin-left: -1em;
    margin-right: -1em;
    min-height: 210px;
  }

  iframe {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border: none;
  }
`
)

export default EmbedResponsive
